<template>
  <div id="worksheet">
    <div class="px3 py4 mb4">
      <h2 class="mb3">Arbejdsseddel</h2>
      <div class="clearfix" v-if="loading">
        <Loading></Loading>
      </div>
      <div v-else>
        <el-table
            :data="workSheetsData"
            border
            style="width: 100%">
            <el-table-column
                prop="projectName"
                label="Project Name">
            </el-table-column>
            <el-table-column
                prop="projectHomeOwner"
                label="Home Owner">
            </el-table-column>
            <el-table-column
                prop="projectAddress"
                label="Project Address">
            </el-table-column>
            <el-table-column
                prop="amount"
                label="Amount">
                <template slot-scope="props">
                  <span>{{formatPrice(props.row.amount)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="futureProject"
                label="Planlagt">
                <template slot-scope="props">
                  <span :class="props.row.futureProject == 1 ? 'bold' : null">{{props.row.futureProject == 0 ? 'Nuværende' : 'Fremtidigt' }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="status"
                label="Status">
                <template slot-scope="props">
                  <span class="bold" :class="props.row.status == 'PAID' ? 'green' : props.row.status == 'REJECTED' ? 'red' : 'mediumgrey'">{{props.row.status}}</span>
                  <el-tooltip :content="props.row.statusChanged" placement="top" effect="light">
                    <i class="shakespeare el-icon-info"></i>
                  </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                prop="week"
                label="Week">
                  <template slot-scope="props">
                    <span>{{props.row.week}}</span>
                    <el-tooltip :content="props.row.week.toString()" placement="top" effect="light">
                      <i class="shakespeare el-icon-info"></i>
                    </el-tooltip>
                  </template>
            </el-table-column>
            <el-table-column
                prop="actions"
                label="Actions">
                  <template slot-scope="props">
                    <a target="_new" :href="props.row.pdf"><i class="shakespeare el-icon-download"></i></a>
                     <button class="transparent border-none" v-if="props.row.status == 'REJECTED'">
                      <i class="red el-icon-delete"></i>
                     </button>
                  </template>
            </el-table-column>
        </el-table>
      </div>
    </div>
     <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<script>
import moment from 'moment'
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  components: {
    Loading,
    ErrorHandler
  },
  name: 'Worksheet',
  data () {
    return {
      loading: true,
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      workSheetsData: []
    }
  },
  mounted () {
    this.getWorkSheet()
  },
  methods: {
    getWorkSheet () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/worksheets', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.data && res.data.length > 0) {
            res.data.forEach((prop, propIndex) => {
              this.workSheetsData.push({projectName: prop.project.NAME,
                projectHomeOwner: prop.project.HOMEOWNER.NAME,
                projectAddress: prop.project.ADDRESS.ADDRESS,
                status: prop.worksheet.UF_STATUS,
                amount: prop.worksheet.UF_AMOUNT,
                futureProject: prop.worksheet.UF_IS_FUTURE_PROJECT,
                week: prop.worksheet.UF_WEEK,
                pdf: prop.worksheet.UF_LINK_TO_PDF,
                statusChanged: moment(prop.worksheet.UF_STATUS_CHANGED).locale('da').format('LL hh:mm:ss a'),
                actions: ''
              })
            })
          }
          this.loading = false
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    getCurrentNumberOfWeeks (week) {
      // var goBack = todayDate.getDay() % 7 + 6
      // var lastMonday = new Date().setDate(todayDate.getDate() - goBack)
      // var desiredDate = new Date(lastMonday)
      // return moment(desiredDate).locale('da').format('LL')
    },
    formatPrice (amount) {
      let formatter = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2
      })
      var tempno = formatter.format(amount)
      return tempno
    }
  }
}
</script>
<style>
  #worksheet .el-input-number input {
    text-align: left
  }
</style>


// WEBPACK FOOTER //
// worksheet.vue?a603ca48